module.exports = __webpack_public_path__ + "static/media/amazing-gray.e357e74a.svg";